import {
  Button as AntButton,
  Col,
  Row,
  Typography,
  Modal,
  Card,
  Select,
  Input as AntInput,
  DatePicker,
  Upload,
  Icon,
  Popconfirm,
  message,
  Tag,
  Layout,
  Button,
} from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import AddVaccination from '../../components/Vaccination/addVaccination';
import EditModal from '../../components/Vaccination/editModal';
import { getNetworkVaccination } from '../../services/api/cashless-vaccination';
import AddPartnerModal from '../../components/Vaccination/addPartnerModal';

class NetworkVaccination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vaccinationData: [],
      totalRecords: 0,
      editModal: false,
      editModalData: null,
      addVaccinationModal: false,
      addVaccinationModalData: null,
      addPartnerModal: false,
    };
  }

  componentDidMount() {
    this.fetchNetworkVaccination(this.props.centerId);
  }

  fetchNetworkVaccination = (centerId) => {
    return getNetworkVaccination(centerId)
      .then((response) => {
        console.log(response.body.data, '[response]');
        this.setState({
          vaccinationData: response.body.data,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  editVaccineDetails = (row) => {
    console.log(row, 'row');
    this.setState({
      editModal: true,
      editModalData: row.original,
    });
  };

  openAddVaccinationModal = () => {
    this.setState({
      addVaccinationModal: true,
    });
  };

  openPartnerModal = () => {
    this.setState({
      addPartnerModal: true,
    });
  };

  getColums = () => [
    {
      Header: 'Vaccination Supported by Center ',
      columns: [
        {
          Header: 'Vaccine Id',
          accessor: 'subId',
          Cell: (row) => {
            return row.original.subId;
          },
        },
        {
          Header: 'Vaccine Name',
          accessor: 'vaccineName',
          Cell: (row) => {
            return row.original.vaccineName;
          },
        },
        {
          Header: 'Vaccine Category',
          accessor: 'category',
          Cell: (row) => {
            return row.original.category;
          },
        },
        {
          Header: 'Vaccine Cost',
          accessor: 'vaccineCost',
          Cell: (row) => {
            return row.original.vaccineCost;
          },
        },
        {
          Header: 'Partner Name',
          accessor: 'partnerName',
          Cell: (row) =>
            row.original.partnerId !== undefined &&
            row.original.partnerId !== null ? (
              <span>{row.original.partnerName}</span>
            ) : (
              <span>Partner Is not Assigned</span>
            ),
        },
        {
          Header: 'Child Vaccine',
          accessor: 'childVaccine',
          Cell: (row) =>
            row.original.childVaccine ? <span>True</span> : <span>False</span>,
        },
        {
          Header: 'Age Limit',
          accessor: 'ageLimitText',
          Cell: (row) =>
            row.original.ageLimitText ? (
              <span>{row.original.ageLimitText}</span>
            ) : (
              <span>Not a Children Vaccine</span>
            ),
        },
        {
          Header: 'Vaccine Status',
          accessor: 'activeStatus',
          filterable: true,
          filterMethod: (filter, row) => {
            console.log(filter, row, '[filter]');
            if (filter.value === 'all') {
              return true;
            }
            return row.activeStatus === filter.value;
          },
          Filter: ({ filter, onChange }) => {
            return (
              <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: '100%' }}
                value={filter ? filter.value : 'Inactive'}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                {/* <option value="All">All</option> */}
              </select>
            );
          },
          Cell: (row) => {
            return row.original.activeStatus === 'Active' ? (
              <Tag color="green">{row.original.activeStatus}</Tag>
            ) : row.original.activeStatus === 'Inactive' ? (
              <Tag color="red">{row.original.activeStatus}</Tag>
            ) : (
              ''
            );
          },
        },
        {
          Header: 'Vaccine Gender',
          accessor: '',
          Cell: (row) => {
            return row.original.genderCategory;
          },
        },
        {
          Header: 'Actions',
          accessor: '',
          Cell: (row) => (
            <Col>
              <Button
                type="primary"
                onClick={() => this.editVaccineDetails(row)}
              >
                Edit
              </Button>
              <br />
            </Col>
          ),
        },
      ],
    },
  ];

  render() {
    return (
      <>
        <div className="justify-between">
          <AntButton onClick={this.openAddVaccinationModal} type="primary">
            Add Vaccinations
          </AntButton>

          <AntButton onClick={this.openPartnerModal} type="primary">
            Add Partner
          </AntButton>
        </div>
        <Layout style={{ marginTop: 20 }}>
          {this.state.editModal && (
            <EditModal
              modalIsOpen={this.state.editModal}
              editdata={this.state.editModalData}
              centerId={this.props.centerId}
              handleClose={() => this.setState({ editModal: false })}
              reload={() => this.fetchNetworkVaccination(this.props.centerId)}
            />
          )}
          {this.state.addVaccinationModal && (
            <AddVaccination
              modalIsOpen={this.state.addVaccinationModal}
              handleClose={() => {
                this.setState({ addVaccinationModal: false });
              }}
              reload={() => this.fetchNetworkVaccination(this.props.centerId)}
              centerId={this.props.centerId}
            />
          )}
          {this.state.addPartnerModal && (
            <AddPartnerModal
              modalIsOpen={this.state.addPartnerModal}
              handleClose={() => {
                this.setState({ addPartnerModal: false });
              }}
              // reload={() => this.fetchNetworkVaccination(this.props.centerId)}
              // centerId={this.props.centerId}
              // isPartner={true}
            />
          )}
          <Row>
            <ReactTable
              data={this.state.vaccinationData}
              columns={this.getColums()}
              showPaginationTop
              showPaginationBottom
              loading={this.state.loading}
            />
          </Row>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(NetworkVaccination));
